import { Box, Flex } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import SmartphoneMockup from './smartphoneMockup';
import UsefulLinks from "../../../texts/UsefulLinks/useLinks";

export const SetIconImage = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setIcon.label')} description={t('form.steps.setIcon.description')}>
					{t('form.steps.setIcon.heading')}
				</FormSectionHeading>

				<InputField
					label={t('form.fields.gameIconURL')}
					name="media.icon"
					placeholder="Icon"
					leftText="URL"
					warningText="1:1"
				/>

				<FormSectionAddon>
					<UsefulLinks actionText={t('onboarding.links.graphicSpecs')} file='assets/docs/lightpaper.pdf'/>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<Flex
					alignItems="flex-end"
					justifyContent="center"
				>
					<SmartphoneMockup
						icon={(values as any).media.icon}
						symbol={(values as any).symbol}
					/>
				</Flex>
			</RightColumn>
		</TwoColumn>
	);
};
